<template>
  <div class="bidders-list tab-table">
    <settlement-table :hide-actions="hideActions" :excludeSearchFields="['first_name', 'last_name', 'company_name']"
                      v-if="initialized" enableFrontendExport/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import SettlementTable from "../../../settlements/SettlementTable";
  import {ACTION_BATCH_SETTLEMENT_GENERATE} from "../../../constants";
  import cloneDeep from "lodash/cloneDeep";
  import CustomerService from "@/modules/customer/CustomerService";

  const {mapState} = createNamespacedHelpers('customer/customerView');
  const {mapActions: settlementsMapActions} = createNamespacedHelpers('settlements');

  export default {
    name: "SettlementsList",
    components: {SettlementTable},
    data() {
      return {
        initialized: false,
        hideActions: [
          ACTION_BATCH_SETTLEMENT_GENERATE,
        ],
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
      })
    },
    methods: {
      ...settlementsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      let tmpCustomer = cloneDeep(this.customer)
      let response = await CustomerService.getCustomer(this.customer.uuid, 'shipping_address.country,billing_address.country')
      if (response.success) {
        tmpCustomer = response.body
      }

      this.initialized = true
      await this.updateTableSource({
        source: 'customer',
        customer: tmpCustomer,
        extraFilters: {customer_uuid: this.customer.uuid},
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
